import React from 'react';
import { CustomModal } from './CustomModal';
import { FileIcon } from './FileIcon';

export const AttachmentViewerModal = ({ urls, onClose, onOpenFile }) => {
    if (!urls || urls.length === 0) return null;

    return (
        <CustomModal isOpen={true} onClose={onClose} title={`Tệp đính kèm (${urls.length})`}>
            <ul className="space-y-2">
                {urls.map((url, index) => (
                    <li key={index} className="bg-gray-100 p-3 rounded-lg flex items-center justify-between">
                         <button onClick={() => onOpenFile(url)} className="flex items-center gap-3 text-blue-600 hover:underline">
                            <FileIcon attachmentUrl={url} />
                            <span className="font-medium">{url.split('/').pop()}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </CustomModal>
    );
};
